<template>
  <div class="NavAppBarComponent">
    <v-app-bar
      app
      color="white"
      height="64px"
      :class="toolbarClass"
      :style="toolbarStyle">
      <div v-if="isHomeRoute">
        <span class="branding"><span class="font-weight-black">DHO</span><span
          class="font-weight-thin">Consulting</span></span>
      </div>
      <the-logo v-else width="100px"/>
      <v-spacer/>
      <v-btn icon href="mailto:dan@dhoconsulting.com">
        <v-icon>mdi-email</v-icon>
      </v-btn>

    </v-app-bar>

  </div>
</template>

<script>
  import TheLogo from '../widget/TheLogo'
  import _ from 'lodash'

  export default {
    name: 'NavAppBar',
    components: { TheLogo },
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
    },
    computed: {},
    watch: {},
    mixins: [],
    data: function () {
      return {
        screenWidth: 0,
        toolbarStyle: {},
        toolbarClass: {}
      }
    },
    methods: {
      isHomeRoute: function () {
        // console.info('Route Name' + this.$route.name)
        return this.$route.name === 'home'
      },
      calculateScreenWidth () {
        this.screenWidth = window.innerWidth
      },
      calculateBackgroundColor () {
        const THRESHOLD = 300
        const TRANSPARENCY = 0.1
        let percentage = (window.scrollY > THRESHOLD - (TRANSPARENCY * THRESHOLD) ? THRESHOLD - (TRANSPARENCY * THRESHOLD) : window.scrollY) / THRESHOLD
        percentage = (percentage > 0.4) ? percentage : 0.4
        this.toolbarStyle.background = 'rgba(255,255,255,' + percentage + ')!important'

        if (percentage > 0) {
          this.toolbarClass['elevation-0'] = false
          this.toolbarClass['elevation-4'] = true
        } else {
          this.toolbarClass['elevation-0'] = true
          this.toolbarClass['elevation-4'] = false
        }
      },
      listen () {
        let self = this
        // TODO
        window.addEventListener('scroll', _.throttle(function () {
          self.calculateBackgroundColor()
        }, 30))

        self.calculateBackgroundColor()

      }
    },
    created () {
    },
    mounted () {
      // this.listen()
    }
  }
</script>

<style scoped>
  .NavAppBarComponent {
    .branding {
      font-family: var(--font-display);
    }
  }
</style>
